<template>
  <!--  <video-->
  <!--    playsinline-->
  <!--    preload="auto"-->
  <!--    autoplay-->
  <!--    ref="animation_video"-->
  <!--    muted-->
  <!--  >-->
  <!--    <source-->
  <!--      src="../../assets/videos/loader_animation.mp4"-->
  <!--      type="video/mp4"-->
  <!--      v-if="typeof filename === 'undefined'"-->
  <!--    />-->
  <!--    <source-->
  <!--      src="../../assets/videos/sizefound_animation.mp4"-->
  <!--      type="video/mp4"-->
  <!--      v-if="filename === 'sizefound_animation'"-->
  <!--    />-->
  <!--    <source-->
  <!--      src="../../assets/videos/sizenotfound_animation.mp4"-->
  <!--      type="video/mp4"-->
  <!--      v-if="filename === 'sizenotfound_animation'"-->
  <!--    />-->
  <!--  </video>-->
  <div>
    <img
      ref="animation_video"
      src="../../assets/videos/loader_animation_loop.gif"
      v-if="typeof filename === 'undefined'"
      alt="animation"
      width="180"
    />
    <img
      ref="animation_video"
      src="../../assets/videos/sizefound_animation_loop.gif"
      v-if="filename === 'sizefound_animation'"
      alt="animation"
      width="180"
    />
    <img
      ref="animation_video"
      src="../../assets/videos/sizenotfound_animation_loop.gif"
      v-if="filename === 'sizenotfound_animation'"
      alt="animation"
      width="180"
    />
  </div>
</template>

<script>
export default {
  name: "loaders-animation",
  props: {
    filename: String
  }
};
</script>
